import { IconBase } from "./iconBase.js";
import { Fragment, jsx } from "@emotion/react/jsx-runtime";
//#region src/appstore.tsx
var Appstore = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", {
		d: "m21 8-2.7-3.6a1 1 0 0 0-.8-.4h-11a1 1 0 0 0-.8.4L3 8m18 0v1a3 3 0 0 1-1 2.236M21 8H3m0 0v1a3 3 0 0 0 1 2.236M15 9a3 3 0 0 0 5 2.236M15 9V8m0 1a3 3 0 1 1-6 0m0 0a3 3 0 0 1-5 2.236M9 9V8m5 12v-3a2 2 0 1 0-4 0v3m-6-8.764V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7.764",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeMiterlimit: "10",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.9 3.8A2 2 0 0 1 6.5 3h11a2 2 0 0 1 1.6.8l2.7 3.6a1 1 0 0 1 .2.6v1a4 4 0 0 1-1 2.646V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7.354A4 4 0 0 1 2 9V8a1 1 0 0 1 .2-.6zm.1 9.074V19h4v-2a3 3 0 1 1 6 0v2h4v-6.126a4.01 4.01 0 0 1-4-1.228A4 4 0 0 1 12 13a4 4 0 0 1-3-1.354 3.99 3.99 0 0 1-4 1.228",
		fill: "currentColor"
	}) })
});
//#endregion
export { Appstore };
